import { render, staticRenderFns } from "./QuickAdd.vue?vue&type=template&id=8765472a&"
import script from "./QuickAdd.vue?vue&type=script&lang=js&"
export * from "./QuickAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports